<template>
  <div>
    <div class="main">
      <div class="heard">
        绑定USDT钱包
      </div>
      <div class="conter">
        <el-form :model="bindCardForm" :rules="rules" ref="bindCardForm" label-width="100px" class="demo-bindCardForm" size="small">
          <el-form-item label="账户种类：" class="phone_code">
            <el-select v-model="bindCardForm.AccountType" class="subbranchname" clearable placeholder="钱包类型" style="width:100%;" >
              <el-option v-for="item in UsdtAccountTypes" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="USDT钱包：" class="phone_code" v-show="insTestProp.EnabledUsdt">
            <el-input v-model.trim="bindCardForm.AccountNO"  placeholder="请输入usdt钱包收款地址" onkeyup="this.value=this.value.replace(/\s+/g,'')"></el-input>
          </el-form-item>
          <el-form-item label="USDT二维码：" class="phone_code" v-show="insTestProp.EnabledUsdt">
            <!-- <el-input v-model.trim="bindCardForm.UsdtQrCodePath" placeholder="请选择usdt钱包收款二维码" ></el-input> -->
            <div class="card_box" style="text-align:center;display:flex;overflow:hidden;margin-top:10px;">
              <div class="card_box_left" style="margin:0px auto;width:90%;min-height:200px;">
                <el-upload class="avatar-uploader uploadimg" :accept="imgAccept" action="" :show-file-list="false" :auto-upload="false" :on-change="changeFileBack">
                  <img id="usdtqrcodeImg" v-if="bindCardForm.QrCode" :src="bindCardForm.QrCode" class="avatar">
                  <el-button v-else slot="trigger" class="btn_card" size="small" type="primary">usdt收款二维码</el-button>
                </el-upload>
              </div>
            </div>            
          </el-form-item>
        </el-form>
        <el-button type="primary" class="btn" @click="subSave" :disabled="disabled" style="font-size:20px">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import "../../assets/lib/jquery.min.js";
import api from "../../../static/config.json";
//import Bus from "@/assets/js/bus";
export default {
  name: "bankcode",
  data() {
    var regname = /^[0-9a-zA-Z]+$/;
    var validName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账户名称"));
      } else if (regname.test(value)) {
        callback(new Error("请输入汉字"));
      } else {
        callback();
      }
    };
    var banknumber = /^([1-9]{1})(\d{14}|\d{15}|\d{16}|\d{17}|\d{18})$/;
    var validbanknumber = (rule, value, callback) => {
      // if (value === "") {
      //   callback(new Error("请输入银行卡号"));
      // } else if (!banknumber.test(value)) {
      //   callback(new Error("请输入正确格式的银行卡号"));
      // } else {
      //   callback();
      // }
    };
    return {
      show: "",
      imgAccept: "image/jpeg,image/jpg,image/png,image/bmp",
      disabled: false,
      bindCardForm: {
        PaymNumb: "",
        AccountType: "",
        AccountNO:"",
        QrCode:"",
        QrCodePath:"",
        QrCodeExt:""
      },
      usernameinfo: "",
      currAgentInfo: {},
      bankTypeId: "",
      rules: {
        //验证
        // BankAccountName: [
        //   { min: 2, max: 5, message: "姓名输入有误", trigger: "blur" },
        //   {
        //     required: true,
        //     min: 2,
        //     max: 5,
        //     validator: validName,
        //     trigger: "blur"
        //   }
        // ],
        // CardNO: [
        //   { required: true, validator: validbanknumber, trigger: "blur" }
        // ]
      },
      GetOrgaNamelists: [],
      UsdtAccountTypes: [],
       insTestProp: {
        IsTestIns: true, // 是否测试机构，true测试机构
        UserRelyPhone: true, // 依赖手机号
        UseCustomId: true, // 使用自定义ID,false表示使用系统自动生成，true表示使用自定义ID
        EnabledUsdt: false,
        AllowNonRealNameUserOpenPosition: false
      }
    };
  },
  mounted() {
    // this.GetBankName();
    this.insTestProp = JSON.parse(sessionStorage.getItem("insTestProp"));
    if (this.insTestProp.UserRelyPhone) {
      this.getAgentInfo();
    }
    this.getuserInfo();
    this.getUsdtAccountTypes();
  },
  methods: {

    PickOrga(value) {
      this.bindCardForm.PaymNumb = value;
    },
    subSave() {
     
        if (this.bindCardForm.UsdtAccount == "")
        {
          this.$message.error("请完整填写信息后提交！");
          return;
        }

      this.loading = true;
      let url = "/Account/BindUsdtAccount";
      this.$loginapi.post(url, this.bindCardForm, response => {
        if (response.Ret == 0) {
          this.$message.success(response.Msg);
          let _this = this;
          setTimeout(function() {
            _this.loading = false;
            _this.$router.push("/personaldata");
            //Bus.$emit("activeIndex4", "/personaldata");
          }, 500);
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    //删除账户
    UnBindUsdtAccount() {
      let url = "/Account/UnBindUsdtAccount";
      let postData = [];
      this.$loginapi.post(url, postData, response => {
        if (response.Ret == 0) {
          this.$message.success("银行卡已解除绑定");
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    //获取当前代理人手机号码及认证信息
    getAgentInfo() {
      let url = "/Account/GetUserInfo";
      this.$loginapi.post(
        url,
        this.$store.state.userInfo.UserCode,
        response => {
          if (response.Ret == 0) {
            this.currAgentInfo = response.Data;
            this.showBindCardPage();
          } else {
            this.$message.error(response.Msg);
          }
        }
      );
    },
    getUsdtAccountTypes() {
      let url = "/Account/GetUsdtAccountTypes";
      this.$loginapi.post(
        url,
        "",
        response => {
          if (response.Ret == 0) {
            this.UsdtAccountTypes = response.Data;
          } else {
            this.$message.error(response.Msg);
          }
        }
      );
    },
    //获取当前登录用户身份证信息
    getuserInfo() {
      let infodata = {
        InsCode: this.$store.state.userInfo.InsCode,
        UserCode: this.$store.state.userInfo.UserCode,
        UserType: this.$store.state.userInfo.UserType
      };
      let url = "/RealNameAuth/IsAuthed";
      this.$loginapi.post(url, infodata, response => {
        if (response.Ret == 0) {
          if (response.Data.Result == 0) {
            // this.$alert('账户未实名认证，请先实名认证！', '', {
            // confirmButtonText: '确定',
            // callback: action => {
            //   this.$router.push("/modification/personid");
            //     return;
            // }
            // });
            //  this.showBindCardPage();
            if (this.insTestProp.AllowNonRealNameUserOpenPosition == false){
              this.$message.warning("账户未实名认证，请先实名认证！");
            }
            this.show = true;
          }
          if (response.Data.Result == 1) {
            let url = "/RealNameAuth/GetInfoForMan";
            this.$loginapi.post(url, infodata, response => {
              if (response.Ret == 0) {
                this.usernameinfo = response.Data.RealName;
              } else {
                // this.$message.error(response.Msg);
              }
            });
          }
          if (response.Data.Result == 2) {
            // this.$alert('账户正在实名认证中,请等待审核！', '', {
            // confirmButtonText: '确定',
            // callback: action => {
            //   this.$router.push("/index");
            //   Bus.$emit('activeIndex1','/index')
            //     return;
            // }
            // });
            this.$message.warning("账户正在实名认证中,请等待审核！");
            this.disabled = true;
          }
          if (response.Data.Result == 3) {
            //   this.$alert('账户实名认证失败,请重新实名认证！', '', {
            // confirmButtonText: '确定',
            // callback: action => {
            //   this.$router.push("/modification/personid");
            //    Bus.$emit('activeIndex4','')
            //     return;
            // }
            // });
            this.$message.warning("账户实名认证失败,请重新实名认证！");
            this.disabled = true;
            this.show = true;
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    // 验证账户绑定信息
    showBindCardPage() {
      if (
        this.currAgentInfo.BindPhone == "" ||
        this.currAgentInfo.BindPhone == null
      ) {
        this.$alert("账户未绑定手机号，请先绑定手机号！", "", {
          confirmButtonText: "确定",
          callback: action => {
            this.$router.push("/modification/phone");
            //Bus.$emit("activeIndex4", "");
            return;
          }
        });
      }
    },
    setpersonid() {
      this.$router.push("/modification/personid");
    },

    changeFileBack(file, fileList) {
      let isJPG = file.raw.type === "image/jpeg";
      let isPNG = file.raw.type === "image/png";
      let isBMP = file.raw.type === "image/bmp";
      let isLt100M = file.raw.size / 1024 / 1024 < 100;

      this.bindCardForm.QrCodeExt = file.raw.type;

      if (!isJPG && !isPNG && !isBMP) {
        this.$message.warning("上传图片必须是JPG/PNG/BMP 格式!");
        return;
      }
      if (!isLt100M) {
        this.$message.warning("上传图片大小不能超过 100MB!");
        return;
      }
      this.loading = true;
      var url = "/RealNameAuth/UpLoadPhoto";
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      // console.log(userInfo);
      var postData = {
        file: file.raw,
        InsCode: userInfo.InsCode,
        UserCode: userInfo.UserCode,
        UserType: userInfo.UserType,
        FileType: 9
      };
      let This = this;
      this.$loginapi.postform(url, postData, response => {
        this.loading = false;
        if (response.Ret === 0) {
          let reader = new FileReader();
          reader.readAsDataURL(file.raw);
          reader.onload = function(e) {
            //this.result; // 这个就是base64编码了
            This.bindCardForm.QrCode = this.result;
          };
          this.bindCardForm.QrCodePath = response.Data;
          this.$message.success(response.Msg);
        } else {
          this.$message.error(response.Msg);
        }
      });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/modification/usdtaccount.vue